import { PATHS } from "routes/paths";

export const getParentTicketList = (status, callsView) => {
  if (!status) {
    return "/";
  } else if (status === "closed") {
    return callsView ? PATHS.closedCalls : PATHS.closedTickets;
  } else if (status === "cancelled") {
    return callsView ? PATHS.cancelledCalls : PATHS.closedTickets;
  } else if (status === "vaultAccess") {
    return PATHS.vaultAccessTickets;
  } else if (status === "selfAssigned") {
    return PATHS.selfAssignedTickets;
  } else if (status === "resolved") {
    return callsView ? PATHS.resolvedCalls : PATHS.resolvedTickets;
  } else if (status === "awaiting") {
    return PATHS.awaitingTickets;
  } else if (status === "open") {
    return callsView ? PATHS.openCalls : PATHS.openTickets;
  } else if (status === "all") {
    return callsView ? PATHS.allCalls : PATHS.allTickets;
  } else if (status === "cash") {
    return callsView ? PATHS.cashCalls : PATHS.cashTickets;
  } else if (status === "assigned") {
    return callsView ? PATHS.assignedCalls : PATHS.assignedTickets;
  } else if (status === "allServiceAndNonService") {
    return PATHS.allServiceAndNonServiceCalls;
  }
  return PATHS.allTickets;
};

export const disableTicketEditing = (status) => {
  if (
    status === "Cancelled" ||
    status === "Closed" ||
    status === "In Progress" ||
    status === "Resolved" ||
    status === "Awaiting Customer Approval" ||
    status === "Awaiting Re-Opening"
  )
    return true;
  return false;
};

export const disableTaskEditing = (status) => {
  if (
    status === "Completed" ||
    status === "Awaiting Customer Approval" ||
    status === "Closed" ||
    status === "Cancelled"
  )
    return true;
  return false;
};
export const fixKendoGridContent = (e) => {
  if (e) {
    const tableHeadElm = document.getElementsByClassName("k-table-thead")[0];
    const tableFooterElm = document.getElementsByClassName("k-pager")[0];
    let headerHeight = 0;
    let footerHeight = 0;
    if (tableHeadElm) {
      headerHeight =
        tableHeadElm.getBoundingClientRect().height +
        tableHeadElm.getBoundingClientRect().top;
    }
    if (tableFooterElm) {
      footerHeight = tableFooterElm.getBoundingClientRect().height;
    }
    const container = document.getElementsByClassName("k-grid-container")[0];
    if (container)
      container.style.height = `calc( 100vh - ${headerHeight + footerHeight}px) `;
  }
};

export const getCallOutDepartment = (
  customerShortName,
  activityType,
  region
) => {
  if (activityType === "No SLA Activity" && region === "Dubai")
    return "No SLA Activity";

  if (
    [
      "Cash Operations",
      "Bin Clearance",
      "Cash Removal",
      "Replenishment",
      "CIT Manual Collection",
      "Stationary Request",
    ].includes(activityType)
  ) {
    return "Cash Operations";
  }

  if (
    customerShortName === "GUNNEBO SCDM" &&
    (activityType === "Second Line Maintenance" ||
      activityType === "Phone Support : SLM")
  ) {
    return "Second Line Maintenance";
  }

  return "First Line Maintenance ";
};
export const getRegionForAssignmentGroup = (
  customerShortName,
  type,
  region
) => {
  if (
    customerShortName === "GUNNEBO SCDM" &&
    (type === "Second Line Maintenance" || type === "Phone Support : SLM")
  ) {
    return "All";
  }
  return region;
};

export const isFilterUpdated = (currentFilter, newFilter) => {
  const currentFilters = Object.keys(currentFilter);
  let _isFilterUpdated = false;
  currentFilters.forEach((elm) => {
    if (currentFilter[elm] !== newFilter[elm]) {
      _isFilterUpdated = true;
    }
  });
  return _isFilterUpdated;
};

export const isCallCenterAgent = (user) => {
  return (
    user?.Roles?.includes("Call Center Agent") || user?.Roles?.includes("CCA")
  );
};

export const getCurrentTicketScreen = (dataItem) => {
  if (dataItem.status === "Draft") {
    if (dataItem.activityType === "Facilities Request") {
      return `${PATHS.createFacilityTickets}/${dataItem.ticketId}`;
    }
    if (dataItem.activityType === "Customer Service") {
      return `${PATHS.createCustomerService}/${dataItem.ticketId}`;
    }
    if (dataItem.activityType === "ETISALAT – Third Party") {
      return `${PATHS.createEtisalatThirdParty}/${dataItem.ticketId}`;
    }
    if (dataItem.activityType === "TGM Remote Support") {
      return `${PATHS.createRemoteSupportRequest}/${dataItem.ticketId}`;
    }
    if (dataItem.activityType === "Customer Complaints") {
      return `${PATHS.createCustomerComplaint}/${dataItem.ticketId}`;
    }
    if (dataItem.activityType === "Unusual Event") {
      return `${PATHS.createUnusualEvent}/${dataItem.ticketId}`;
    }
    return `${PATHS.createTicket}/${dataItem.ticketId}`;
  }
  return `${PATHS.ticketDetails}/${dataItem.ticketId}`;
};

export const StatusLists = {
  Draft: [{ id: "Cancelled", text: "Cancel" }],
  Open: [{ id: "Cancelled", text: "Cancel" }],
  Assigned: [{ id: "Cancelled", text: "Cancel" }],
  Resolved: [
    { id: "Rejected", text: "Reject" },
    { id: "CA Requested", text: "Request Customer Approval" },
  ],
  "Awaiting Customer Approval": [
    { id: "Rejected", text: "Reject" },
    { id: "Closed", text: "Close" },
  ],
  Closed: [{ id: "Re-Opening Requested", text: "Request Re-Opening" }],
  "Awaiting Re-Opening": [{ id: "Re-Opened", text: "Re-Open" }],
  "On Hold": [{ id: "Re-Assigned", text: "Re-Assigned" }],
};

// import { client } from "./api-client";
// export const useGetImage = async (path) => {
//   const isLocal =
//     process.env.REACT_APP_LOCAL_FILE_SYSTEM === "true" ||
//     process.env.REACT_APP_LOCAL_FILE_SYSTEM === true;

//   try {
//     const response = await client(
//       isLocal
//         ? `common/download/local?path=${path}`
//         : `common/download/cloud?url=${path}`,
//       {
//         config: { responseType: "blob" },
//       }
//     );
//     const blob = new Blob([response.data]);
//     const url = URL.createObjectURL(blob);
//     return url;
//   } catch (e) {
//     //empty
//     return "";
//   }
// };
